import type { ILibraryListItem } from "@/api/library-documents/library-documents.types";

/**
 * Filter the scope/comparison picker's selectable list. Spreadsheets
 * (`.xlsx`/`.csv`) are NOT selectable into scope/comparison analysis — this is
 * the by-id selection path the backend (`create_scope`, Slice 1) also rejects.
 *
 * Spreadsheet-POSITIVE predicate (`file_type in {"xlsx","csv"}`), NEVER
 * `!== "pdf"`: a legacy `null`-`file_type` document must remain selectable, so a
 * naive not-pdf filter would wrongly drop every pre-feature row.
 *
 * KNOWN LIMITATION: this filters client-side AFTER server pagination, so a page
 * that is mostly spreadsheets renders short/empty and `rowCount` still counts
 * them. A complete fix needs an `exclude_spreadsheets` filter on the list
 * endpoint so pagination stays correct; until then the picker still rejects
 * spreadsheets on submit (`create_scope`).
 */
export function filterSelectableDocuments(
    items: ILibraryListItem[]
): ILibraryListItem[] {
    // Spreadsheet-POSITIVE: drop only xlsx/csv; a legacy `null` file_type (and
    // every pdf) stays selectable.
    return items.filter(
        (item) => item.file_type !== "xlsx" && item.file_type !== "csv"
    );
}
